module.exports = __webpack_public_path__ + "img/267F.b0412b89.svg";